export default __webpack_public_path__ + "static/media/hus_2.abc1fab6.svg";